const ORDER = ["GK", "DEF", "DM", "MID", "AM", "FWD"];

function textOn(hex) {
  const h = (hex || "#000").replace("#", "");
  const [r, g, b] = [0, 2, 4].map((i) => parseInt(h.slice(i, i + 2), 16) || 0);
  return 0.299 * r + 0.587 * g + 0.114 * b > 150 ? "#050505" : "#FFFFFF";
}

function lastName(p) {
  const n = p.short_name || p.name || "";
  const parts = n.split(" ");
  const rest = parts.length > 1 && parts[0].endsWith(".") ? parts.slice(1) : [parts[parts.length - 1]];
  return rest.length > 1 && rest.join(" ").length > 10 ? rest[rest.length - 1] : rest.join(" ");
}

// Lines spread evenly over each half: top half = away (attacking down), bottom half = home.
function layout(team, isHome) {
  if (!team) return [];
  const lines = ORDER.filter((r) => team.players.some((p) => p.role === r));
  const n = lines.length;
  return team.players.map((p) => {
    const idx = lines.indexOf(p.role);
    const t = n > 1 ? idx / (n - 1) : 0;
    const y = 6 + t * 37;
    return { ...p, top: isHome ? 100 - y : y, left: isHome ? p.x : 100 - p.x };
  });
}

function PlayerDot({ p, color }) {
  return (
    <div className="absolute -translate-x-1/2 -translate-y-1/2 flex flex-col items-center z-10 w-[19%]" style={{ left: `${p.left}%`, top: `${p.top}%` }} title={`${p.name} · ${p.position}`}>
      <div className="w-7 h-7 sm:w-9 sm:h-9 rounded-full border-2 border-black/60 ring-1 ring-white/80 grid place-items-center text-[10px] sm:text-xs font-black shadow-lg mono" style={{ background: color, color: textOn(color) }}>
        {p.jersey || p.position}
      </div>
      <div className="mt-0.5 max-w-full px-1 py-0.5 bg-black/75 text-[9px] sm:text-[11px] font-bold text-white leading-tight text-center truncate">{lastName(p)}</div>
    </div>
  );
}

function LineupList({ team, name, color, side }) {
  if (!team) return null;
  const players = [...team.players].sort((a, b) => ORDER.indexOf(a.role) - ORDER.indexOf(b.role) || a.x - b.x);
  return (
    <div data-testid={`lineup-list-${side}`}>
      <div className="flex items-center gap-2 mb-2">
        <span className="w-2.5 h-2.5" style={{ background: color }} />
        <span className="heading text-base font-black truncate">{name}</span>
        <span className="label text-[10px] ml-auto">{team.formation}</span>
      </div>
      <div className="space-y-0.5">
        {players.map((p) => (
          <div key={p.id || p.name} className="grid grid-cols-[28px_1fr_40px] gap-2 text-sm py-1 border-b border-[#1f1f22]">
            <span className="mono text-[#71717A] text-right">{p.jersey}</span>
            <span className="truncate">{p.name}</span>
            <span className="label text-[9px] text-right self-center">{p.position}</span>
          </div>
        ))}
      </div>
      {team.bench?.length > 0 && <p className="text-[11px] text-[#71717A] mt-2 leading-relaxed"><span className="label text-[9px]">Panchina: </span>{team.bench.join(", ")}</p>}
    </div>
  );
}

export default function PitchFormation({ home, away, homeColor = "#007AFF", awayColor = "#FF3B30", homeName, awayName }) {
  const dots = [...layout(away, false).map((p) => ({ p, c: awayColor })), ...layout(home, true).map((p) => ({ p, c: homeColor }))];
  return (
    <div className="grid grid-cols-1 xl:grid-cols-[minmax(0,1.3fr)_minmax(0,1fr)] gap-6">
      <div className="pitch w-full aspect-[1/2] sm:aspect-[3/5] relative" data-testid="pitch-formation">
        {dots.map(({ p, c }) => <PlayerDot key={`${c}-${p.id || p.name}`} p={p} color={c} />)}
        <div className="absolute top-3 right-4 label text-[10px] text-white/80 z-10">{awayName} · {away?.formation || "n/d"}</div>
        <div className="absolute bottom-3 right-4 label text-[10px] text-white/80 z-10">{homeName} · {home?.formation || "n/d"}</div>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-1 gap-6">
        <LineupList team={home} name={homeName} color={homeColor} side="home" />
        <LineupList team={away} name={awayName} color={awayColor} side="away" />
      </div>
    </div>
  );
}
